<template>
    <!-- Solicitud de visita con el diseño de Cambiar contraseña / Mi perfil:
         lateral (título, alojamiento y avance de lo obligatorio) + tarjetas
         numeradas + barra de estado. Mismos campos y misma API que antes. -->
    <form :class="['fx-vis', { 'fx-vis--modal': inModal, 'is-sending': form_data.sending }]" novalidate @submit.prevent="sendForm()">
        <button v-if="inModal" type="button" class="fx-vis-x" :aria-label="$t('ficha_nueva.close')" :disabled="form_data.sending" @click="$emit('close')">×</button>

        <input type="hidden" v-model="form_data.id_alojamiento" />

        <div class="fx-vis-scroll">
            <div class="fx-vis-lay">
                <aside class="fx-vis-side">
                    <h2 class="fx-vis-title">{{ $t('ficha_nueva.visit.title_a') }} <span class="fx-vis-hl">{{ $t('ficha_nueva.visit.title_b') }}</span></h2>
                    <p class="fx-vis-sub">{{ $t('ficha_nueva.visit.subtitle') }}</p>

                    <div v-if="alojamiento" class="fx-vis-place">
                        <img v-if="fotoAlojamiento" :src="fotoAlojamiento" alt="" />
                        <div>
                            <p class="fx-vis-place-t">{{ tituloAlojamiento }}</p>
                            <p class="fx-vis-place-d">ID {{ alojamiento.idalojamiento }}</p>
                        </div>
                    </div>

                    <ol class="fx-vis-prog" :aria-label="$t('ficha_nueva.visit.required')">
                        <li v-for="r in requeridos" :key="r.k" :class="{ 'is-ok': !errores[r.k] }">
                            <span class="fx-vis-dot" aria-hidden="true">{{ errores[r.k] ? '' : '✓' }}</span>{{ r.t }}
                            <span class="fx-vis-sr">{{ errores[r.k] ? $t('ficha_nueva.visit.missing') : $t('ficha_nueva.visit.ready') }}</span>
                        </li>
                        <li class="fx-vis-pct" aria-hidden="true"><span :style="{ width: (listos / requeridos.length * 100) + '%' }"></span></li>
                    </ol>
                </aside>

                <div class="fx-vis-main">
                    <!-- 1 · Tus datos -->
                    <section :class="['fx-vis-card', { 'is-done': !errores.nombre && !errores.correo }]" aria-labelledby="fxv-1">
                        <header class="fx-vis-card-head">
                            <span class="fx-vis-step" aria-hidden="true">{{ !errores.nombre && !errores.correo ? '✓' : '1' }}</span>
                            <div>
                                <h3 id="fxv-1" class="fx-vis-card-t">{{ $t('ficha_nueva.visit.s1_title') }}</h3>
                                <p class="fx-vis-card-d">{{ autofilled.nombre || autofilled.correo ? $t('ficha_nueva.visit.s1_desc_profile') : $t('ficha_nueva.visit.s1_desc') }}</p>
                            </div>
                        </header>
                        <div class="fx-vis-grid">
                            <BkField id="nombre" v-model="form_data.nombre" :label="$t('ficha_nueva.visit.name')" :disabled="autofilled.nombre" :error="errorDe('nombre')" @blur="tocar('nombre')" />
                            <BkField id="telefono" v-model="form_data.telefono" :label="$t('ficha_nueva.visit.phone')" :disabled="autofilled.telefono" inputmode="tel" optional :optionalText="$t('ficha_nueva.visit.optional')" />
                        </div>
                        <BkField id="correo" v-model="form_data.correo" type="email" :label="$t('ficha_nueva.visit.email')" :disabled="autofilled.correo" :error="errorDe('correo')" @blur="tocar('correo')" />
                    </section>

                    <!-- 2 · Día de la visita -->
                    <section :class="['fx-vis-card', { 'is-done': !errores.visita }]" aria-labelledby="fxv-2">
                        <header class="fx-vis-card-head">
                            <span class="fx-vis-step" aria-hidden="true">{{ !errores.visita ? '✓' : '2' }}</span>
                            <div>
                                <h3 id="fxv-2" class="fx-vis-card-t">{{ $t('ficha_nueva.visit.s2_title') }}</h3>
                                <p class="fx-vis-card-d">{{ $t('ficha_nueva.visit.s2_desc') }}</p>
                            </div>
                        </header>
                        <BkField id="visita" v-model="form_data.visita" type="date" fijo :label="$t('ficha_nueva.visit.visit_day')" :error="errorDe('visita')" @blur="tocar('visita')" />
                    </section>

                    <!-- 3 · Tu estadía -->
                    <section :class="['fx-vis-card', { 'is-done': !errores.fecha_inicio && !errores.fecha_termino }]" aria-labelledby="fxv-3">
                        <header class="fx-vis-card-head">
                            <span class="fx-vis-step" aria-hidden="true">{{ !errores.fecha_inicio && !errores.fecha_termino ? '✓' : '3' }}</span>
                            <div>
                                <h3 id="fxv-3" class="fx-vis-card-t">{{ $t('ficha_nueva.visit.s3_title') }}</h3>
                                <p class="fx-vis-card-d">{{ $t('ficha_nueva.visit.s3_desc') }}</p>
                            </div>
                        </header>
                        <div class="fx-vis-grid">
                            <BkField id="fecha_inicio" v-model="form_data.fecha_inicio" type="date" fijo :label="$t('ficha_nueva.visit.check_in')" :error="errorDe('fecha_inicio')" @blur="tocar('fecha_inicio')" />
                            <BkField id="fecha_termino" v-model="form_data.fecha_termino" type="date" fijo :label="$t('ficha_nueva.visit.check_out')" :error="errorDe('fecha_termino')" @blur="tocar('fecha_termino')" />
                        </div>
                        <p v-if="noches > 0" class="fx-vis-nights">{{ $tc('ficha_nueva.nights', noches, { n: noches }) }}</p>
                    </section>

                    <!-- 4 · Mensaje (opcional) -->
                    <section class="fx-vis-card" aria-labelledby="fxv-4">
                        <header class="fx-vis-card-head">
                            <span class="fx-vis-step fx-vis-step--muted" aria-hidden="true">4</span>
                            <div>
                                <h3 id="fxv-4" class="fx-vis-card-t">{{ $t('ficha_nueva.visit.s4_title') }} <small class="fx-vis-opt">{{ $t('ficha_nueva.visit.optional') }}</small></h3>
                                <p class="fx-vis-card-d">{{ $t('ficha_nueva.visit.s4_desc') }}</p>
                            </div>
                        </header>
                        <BkField id="mensaje_anfitrion" v-model="form_data.mensaje" textarea :maxlength="500" :label="$t('ficha_nueva.visit.message')" />
                    </section>
                </div>
            </div>
        </div>

        <div class="fx-vis-foot">
            <p :class="['fx-vis-state', { 'is-ok': listos === requeridos.length && !form_data.code_api, 'is-bad': !!form_data.code_api }]" aria-live="polite">
                <span class="fx-vis-state-dot" aria-hidden="true"></span>
                <template v-if="form_data.code_api">{{ form_data.code_api }}</template>
                <template v-else-if="form_data.update">{{ $t('ask-visit.sent') }}</template>
                <template v-else-if="listos === requeridos.length">{{ $t('ficha_nueva.visit.ready_to_send') }}</template>
                <template v-else>{{ $tc('ficha_nueva.visit.left', requeridos.length - listos, { n: requeridos.length - listos, total: requeridos.length }) }}</template>
            </p>
            <div class="fx-vis-acts">
                <button v-if="inModal" type="button" class="fx-btn fx-btn--ghost" :disabled="form_data.sending" @click="$emit('close')">{{ $t('ficha_nueva.cancel') }}</button>
                <button v-if="!form_data.update" type="submit" class="fx-btn fx-btn--primary" :disabled="form_data.sending">
                    <span v-if="form_data.sending" class="fx-spin" aria-hidden="true"></span>
                    {{ form_data.sending ? $t('ficha_nueva.visit.sending') : $t('ficha_nueva.request_visit') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { mapState } from "vuex";
import BkField from "@/components/BankInformation/BkField.vue";

export default {
    name: 'RequestAccommodationVisit',
    components: { BkField },
    props: {
        accommodationId: {
            type: [String, Number],
            required: false,
            default: null
        },
        inModal: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            form_data: {
                id_alojamiento: this.accommodationId || (this.$route && this.$route.params ? this.$route.params.accommodationId : null),
                nombre: "",
                visita: "",
                correo: "",
                mensaje: "",
                fecha_inicio: "",
                fecha_termino: "",
                telefono: "",
                update: false,
                code_api: false,
                sending: false
            },
            // Campos que ya se tocaron (el error se muestra al salir del campo o al enviar)
            tocados: {},
            intentado: false,
            autofilled: {
                nombre: false,
                correo: false,
                telefono: false,
            },
        };
    },
    created() {
        const st = this.$store && this.$store.state && this.$store.state.search;
        if (st && st.checkInDate && !this.form_data.fecha_inicio) this.form_data.fecha_inicio = String(st.checkInDate).slice(0, 10);
        if (st && st.checkOutDate && !this.form_data.fecha_termino) this.form_data.fecha_termino = String(st.checkOutDate).slice(0, 10);
        if (!this.inModal) {
            window.scrollTo(0, 0);
        }
        // Autocompletar campos si hay sesión iniciada (store o localStorage)
        try {
            const usuarioJson = localStorage.getItem('usuario');
            let storeUser = this.$store && this.$store.state ? this.$store.state.user : null;
            let localUser = null;
            if (usuarioJson) {
                try { localUser = JSON.parse(usuarioJson); } catch (e) { localUser = null; }
            }

            // Prefer storeUser values but fallback to localUser when missing
            // Solo autocompletar el nombre (sin apellidos)
            const nombre = (storeUser && (storeUser.nombre || storeUser.first_name)) || (localUser && (localUser.nombre || localUser.first_name)) || '';
            const nombreTrim = (nombre || '').toString().trim();
            const correo = (storeUser && (storeUser.correo || storeUser.email)) || (localUser && (localUser.correo || localUser.email)) || null;
            const telefono = (storeUser && (storeUser.telefono || storeUser.phone || storeUser.celular || storeUser.phone_number))
                || (localUser && (localUser.telefono || localUser.phone || localUser.celular || localUser.phone_number))
                || null;

            if (nombreTrim) {
                this.form_data.nombre = nombreTrim;
                this.autofilled.nombre = true;
            }
            if (correo) {
                this.form_data.correo = correo;
                this.autofilled.correo = true;
            }
            if (telefono) {
                this.form_data.telefono = String(telefono);
                this.autofilled.telefono = true;
            }
        } catch (e) {
            // no bloquear si algo falla
        }
    },
    computed: {
        ...mapState('accommodation', ['accommodation']),

        // El alojamiento cargado en la ficha, si es este (en la página suelta puede no estar).
        alojamiento() {
            const a = this.accommodation;
            return a && String(a.idalojamiento) === String(this.form_data.id_alojamiento) ? a : null;
        },
        tituloAlojamiento() {
            const a = this.alojamiento;
            if (!a) return '';
            if (a.propiedad && a.propiedad.nombre) return a.propiedad.nombre;
            return this.$t('accommodation.title.' + a.tipo + '-' + a.categoria);
        },
        fotoAlojamiento() {
            const a = this.alojamiento;
            const f = a && Array.isArray(a.photos) && a.photos.length ? a.photos[0].url : '';
            if (!f) return '';
            return f.indexOf('http') === -1 ? (process.env.VUE_APP_S3_URL || '') + f : f;
        },

        requeridos() {
            return [
                { k: 'visita', t: this.$t('ficha_nueva.visit.visit_day') },
                { k: 'fecha_inicio', t: this.$t('ficha_nueva.visit.check_in') },
                { k: 'fecha_termino', t: this.$t('ficha_nueva.visit.check_out') },
            ];
        },
        // Mismas reglas que validateForm (obligatorios y salida ≥ ingreso), por campo.
        errores() {
            const f = this.form_data, e = {};
            const vacio = v => !v || String(v).trim() === '';
            if (vacio(f.nombre)) e.nombre = this.$t('ficha_nueva.visit.err_required');
            if (vacio(f.correo)) e.correo = this.$t('ficha_nueva.visit.err_required');
            if (vacio(f.visita)) e.visita = this.$t('ficha_nueva.visit.err_visit');
            if (vacio(f.fecha_inicio)) e.fecha_inicio = this.$t('ficha_nueva.visit.err_in');
            if (vacio(f.fecha_termino)) e.fecha_termino = this.$t('ficha_nueva.visit.err_out');
            else if (!vacio(f.fecha_inicio) && f.fecha_termino < f.fecha_inicio) e.fecha_termino = this.$t('ficha_nueva.visit.err_order');
            return e;
        },
        listos() {
            return this.requeridos.filter(r => !this.errores[r.k]).length;
        },
        noches() {
            const a = this.form_data.fecha_inicio, b = this.form_data.fecha_termino;
            if (!a || !b || b <= a) return 0;
            return Math.round((new Date(b + 'T12:00:00') - new Date(a + 'T12:00:00')) / 864e5);
        },
    },
    watch: {
        'form_data.fecha_inicio'() { this.form_data.code_api = false; },
        'form_data.fecha_termino'() { this.form_data.code_api = false; },
        'form_data.visita'() { this.form_data.code_api = false; },
        accommodationId: {
            immediate: false,
            handler(newValue) {
                if (newValue !== undefined && newValue !== null && newValue !== '') {
                    this.form_data.id_alojamiento = newValue;
                }
            }
        }
    },
    methods: {
        tocar(k) { this.$set(this.tocados, k, true); },
        errorDe(k) { return (this.intentado || this.tocados[k]) && this.errores[k] ? this.errores[k] : ''; },

        validateForm() {
            // Lista de campos requeridos (coincide con los inputs visibles en esta vista)
            const requiredFields = [
                'nombre',
                'correo',
                'visita',
                'fecha_inicio',
                'fecha_termino'
            ];

            for (const field of requiredFields) {
                if (!this.form_data[field] || this.form_data[field].toString().trim() === '') {
                    this.form_data.code_api = this.$t('ask-visit.complete-all-fields');
                    return false;
                }
            }

            // Validación básica: salida no puede ser anterior a ingreso
            if (this.form_data.fecha_inicio && this.form_data.fecha_termino && this.form_data.fecha_termino < this.form_data.fecha_inicio) {
                this.form_data.code_api = 'La fecha de salida no puede ser anterior a la de ingreso';
                return false;
            }

            return true;
        },
        sendForm() {
            // Validar antes de enviar (y llevar el foco al primer campo con error)
            this.intentado = true;
            if (!this.validateForm()) {
                this.$nextTick(() => {
                    const orden = ['nombre', 'correo', 'visita', 'fecha_inicio', 'fecha_termino'];
                    const primero = orden.find(k => this.errores[k]);
                    const el = primero && this.$el.querySelector('#' + primero);
                    if (el && !el.disabled) el.focus();
                });
                return;
            }
            this.form_data.sending = true;
            this.form_data.code_api = false;
            let id_alojamiento = this.form_data.id_alojamiento;
            var formData = new FormData();


            // Campos que realmente provienen de los inputs del formulario
            const allowedFields = [
                'id_alojamiento',
                'nombre',
                'correo',
                'visita',
                'mensaje',
                'fecha_inicio',
                'fecha_termino',
                'telefono'
            ];

            // Añadir solo los campos permitidos y con valor.
            allowedFields.forEach((key) => {
                const value = this.form_data[key];
                if (value !== undefined && value !== null && value !== '') {
                    formData.append(key, value);
                }
            });

            // Añadir idioma por separado
            formData.append('language', this.$i18n.locale);
            const url = process.env.VUE_APP_API_URL + `reservations/solicitar/${id_alojamiento}`;
            axios.post(url, formData)
                .then((response) => {
                    this.form_data.sending = false;
                    this.form_data.update = true;

                    if (this.inModal) {
                        this.$emit('success');
                        return;
                    }

                    router.push({
                        name: "request-visit-success",
                        params: { accommodationId: this.form_data.id_alojamiento }
                    });
                })
                .catch((error) => {
                    this.form_data.sending = false;
                    const msg = (error && error.response && error.response.data && (error.response.data.message || error.response.data.error))
                        ? (error.response.data.message || error.response.data.error)
                        : (this.$t('ask-visit.error') || 'Error al enviar la solicitud');
                    this.form_data.code_api = msg;
                    console.log(error.response || error);
                });
        },
    }
};
</script>



<style lang="scss" scoped>
.visit-card.container {
    max-width: 720px;
    margin: 28px auto;
    background: #fff;
    padding: 28px;
    border-radius: 28px;
    box-shadow: 0 14px 52px rgba(0, 0, 0, 0.14);
    border: 1px solid #eee;
    position: relative;
}

.visit-card--sending {
    overflow: hidden;
}

.visit-loading {
    min-height: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
}

.visit-loading__spinner {
    width: 44px;
    height: 44px;
    border-radius: 999px;
    border: 4px solid rgba(0, 0, 0, 0.08);
    border-top-color: #e57217;
    animation: visit-spin 0.9s linear infinite;
}

.visit-loading__text {
    color: #333;
    font-weight: 600;
}

@keyframes visit-spin {
    to { transform: rotate(360deg); }
}

.visit-card--modal.container {
    width: 94%;
    max-width: 640px;
    margin: 0 auto;
    // El scroll debe estar dentro de la tarjeta, no en la página
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    border-radius: 28px;

    // Ocultar barra de scroll manteniendo el scroll
    -ms-overflow-style: none; // IE/Edge legacy
    scrollbar-width: none; // Firefox
}

.visit-card--modal.container::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.visit-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 38px;
    height: 38px;
    border-radius: 999px;
    background: #eee;
    border: 0;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 120ms ease, color 120ms ease;
}

.visit-close__icon {
    display: block;
    font-size: 26px;
    line-height: 1;
    transform: translateY(-1px);
}

.visit-close:hover,
.visit-close:focus {
    background: #dc3545;
    color: #fff;
    outline: none;
}

.card-header {
    margin-bottom: 18px;
}
.card-header h3 {
    margin: 0 0 6px 0;
    font-weight: 600;
}
.card-header .muted {
    color: #7a7a7a;
    font-size: 0.95rem;
    margin: 0;
}

.visit-card label {
    display: block;
    margin-top: 12px;
    font-weight: 600;
    color: #333;
}

.visit-card h4 {
    margin-top: 12px;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 1rem;
    color: #333;
}

.form-control,
select.form-control,
textarea.form-control,
.custom-select {
    border-radius: 18px;
    background: #fbfbfb;
    border: 1px solid #eee;
    box-shadow: none;
    transition: box-shadow 160ms ease, transform 120ms ease;
}

.form-control-lg {
    height: 52px;
    padding: 10px 14px;
}

.phone-row .custom-select,
.phone-row .form-control-lg {
    height: 52px;
    border-radius: 18px;
}

.readonly-input {
    background-color: #e9ecef !important;
    cursor: not-allowed;
}

.status-row {
    margin-top: 14px;
    min-height: 24px;
}
.status-row small {
    display: inline-block;
    margin-right: 8px;
}

.submit-full {
    display: block;
    width: 300px;
    max-width: 90%;
    padding: 12px 18px;
    margin: 18px auto 0;
    background-color: #e57217;
    border: none;
    border-radius: 20px;
    color: #fff;
    font-weight: 700;
    box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    transition: transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease;
}

.form-control:focus,
.custom-select:focus,
select.form-control:focus,
textarea.form-control:focus {
    outline: none;
    box-shadow: 0 6px 18px rgba(0,0,0,0.06);
    transform: translateY(-1px);
}

</style><style src="./fichaVisita.css"></style>
